import React from 'react';
import { SvgIcon } from '@mui/material';

interface ISummarizeIconProps extends React.ComponentPropsWithoutRef<typeof SvgIcon> {
  activeBullet: number; // 0 = no active bullet (all use outline color), 1 = top, 2 = middle, 3 = bottom
  summarizingInProgress: boolean; // Whether the animation/loading is happening
  outlineColor?: string; // Optional outline color (default to #CCCCCC)
}

export function SummarizeIcon(props: ISummarizeIconProps) {
  const { activeBullet, summarizingInProgress, outlineColor = '#CCCCCC', ...restProps } = props;

  const getBulletColor = (bulletIndex: number) => {
    if (!summarizingInProgress) {
      return outlineColor; // Use outline color when not summarizing
    }
    return activeBullet === bulletIndex ? 'red' : outlineColor; // Highlight active bullet, others use outline color
  };

  return (
    <SvgIcon {...restProps}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
        {/* Top bullet */}
        <path
          d="M320-600q17 0 28.5-11.5T360-640q0-17-11.5-28.5T320-680q-17 0-28.5 11.5T280-640q0 17 11.5 28.5T320-600Z"
          fill={getBulletColor(1)}
        />
        {/* Middle bullet */}
        <path
          d="M320-440q17 0 28.5-11.5T360-480q0-17-11.5-28.5T320-520q-17 0-28.5 11.5T280-480q0 17 11.5 28.5T320-440Z"
          fill={getBulletColor(2)}
        />
        {/* Bottom bullet */}
        <path
          d="M320-280q17 0 28.5-11.5T360-320q0-17-11.5-28.5T320-360q-17 0-28.5 11.5T280-320q0 17 11.5 28.5T320-280Z"
          fill={getBulletColor(3)}
        />
        {/* Icon outline */}
        <path
          d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h440l200 200v440q0 33-23.5 56.5T760-120H200Zm0-80h560v-400H600v-160H200v560Zm0-560v160-160 560-560Z"
          fill={outlineColor}
        />
      </svg>
    </SvgIcon>
  );
}
